import { Controller } from "@hotwired/stimulus";

// Generic "please wait" feedback for a plain native form submit that isn't
// otherwise intercepted by fetch/Stimulus (e.g. step4's payment method
// forms, which really do post-and-navigate to a payment gateway or the
// next page) -- listens for the bubbling submit event from any descendant
// form and disables that form's own submit button + shows a small spinner
// next to it, without calling preventDefault() so the real navigation
// still proceeds exactly as before. Same spinner every other step-to-step
// "please wait" moment in the funnel uses (common/_button_spinner.html.erb).
export default class extends Controller {
  submit(event) {
    // Skip if an earlier action on this same submit event already
    // rejected it (e.g. seat-map#validateSubmit's preventDefault() when
    // nothing's selected) -- preventDefault() only cancels the actual
    // navigation, it doesn't stop other listeners bound to the same
    // event, so without this check the button would show "please wait"
    // and disable itself even on a submission that never actually went
    // anywhere, leaving the user stuck with no way to retry.
    if (event.defaultPrevented) return;

    const form = event.target;
    const button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!button || button.disabled) return;

    button.disabled = true;
    const spinner = document.createElement("span");
    spinner.className = "inline-flex ml-2 align-middle";
    spinner.innerHTML = '<svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>';
    button.appendChild(spinner);
  }
}
